import Vue from "vue";

// Shared event bus between the alert controller and the root dialog component.
export const confirmDialogBus = new Vue();
